<script setup>
import { mapState } from "vuex";
import DistanceSettingInput from "@/components/Project/DistanceSettingInput.vue";
import { useUnitDisplay } from "@/composables/useUnitDisplay";

const { toDisplayDistance } = useUnitDisplay();

const toDisplayDistanceValue = (value) => {
	if (value === undefined || value === null || Number.isNaN(Number(value))) {
		return value;
	}
	return toDisplayDistance(Number(value), 3).value;
};

const props = defineProps({
	source: Object, // {x,y,z}
	destination: Object, //{x,y,z}
});
</script>
<template>
  <v-card class="fixedPos">
    <v-container class="d-flex flex-column">
      <span>{{ $t("SOURCE_POINT") }}</span>
      <div class="d-flex flex-row ga-sm-1">
        <span> x:</span>
        <span> {{ toDisplayDistanceValue(source.y) }}</span>
      </div>
      <div class="d-flex flex-row ga-sm-1">
        <span> y:</span>
        <span> {{ toDisplayDistanceValue(source.x) }}</span>
      </div>
      <div class="d-flex flex-row ga-sm-1">
        <span> z:</span>
        <span> {{ toDisplayDistanceValue(source.z) }}</span>
      </div>
    </v-container>
    <v-container>
      <span>{{ $t("DESTINATION_POINT") }}</span>
      <div v-if="showInput">
        <v-form>
          <DistanceSettingInput hide-details hide-spin-buttons type="number" v-model="destination.y" label="x"
            @blur="updateDestinationPosition" />
          <DistanceSettingInput hide-details hide-spin-buttons type="number" v-model="destination.x" label="y"
            @blur="updateDestinationPosition" />
          <DistanceSettingInput disabled hide-details hide-spin-buttons type="number" v-model="destination.z"
            label="z" />
        </v-form>
      </div>
      <div v-if="!showInput">
        <div class="d-flex flex-row ga-sm-1">
          <span> x:</span>
          <span> {{ toDisplayDistanceValue(destination.y) }}</span>
        </div>
        <div class="d-flex flex-row ga-sm-1">
          <span> y:</span>
          <span> {{ toDisplayDistanceValue(destination.x) }}</span>
        </div>
        <div class="d-flex flex-row ga-sm-1">
          <span> z:</span>
          <span> {{ toDisplayDistanceValue(destination.z) }}</span>
        </div>
      </div>
    </v-container>
    <v-container class="d-flex flex-row ga-sm-1">
      <v-btn variant="flat" width="120px" min-height="31px" color="red" @click="onCancel">{{ $t("CANCEL") }}</v-btn>
      <v-btn variant="flat" width="120px" min-height="31px" color="primary" @click="onSubmit">{{ $t("OK") }}</v-btn>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {
    DistanceSettingInput
  },
  data() {
    return {
      showInput: true,
      point: { x: undefined, y: undefined, z: undefined }
    }
  },
  computed: {
    ...mapState("drawing2dImage", ["pointsOfTwoPointAlignment"]),
    isLockStart() {
      const count = this.pointsOfTwoPointAlignment.filter(item => !!item).length;
      return count === 2;
    }
  },
  methods: {
    onSubmit() {
      this.$emit("onSubmit", this.point);
    },
    onCancel() {
      this.$emit("onCancel");
    },
    async updateDestinationPosition() {
      if (this.destination && this.destination.x !== undefined && this.destination.y !== undefined && this.destination.z !== undefined) {
        try {
          await this.$store.dispatch('drawing2dImage/updateDestinationPosition', {
            position: { x: this.destination.x, y: this.destination.y, z: this.destination.z }
          });
        } catch (e) {
          console.warn('Failed to update destination position:', e);
        }
      }
    }
  },
}
</script>

<style lang="css" scoped>
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vw;
  background-color: transparent;
}

.fixedPos {
  position: absolute;
  display: block;
  width: fit-content;
  z-index: 9999;
}
</style>